import styled from 'styled-components';

export const AssistantStatus = styled.p`
  margin: 0;
  padding: 24px 16px;
  text-align: center;
  font-size: 13px;
  color: ${({ theme }) => theme.colors.onSurfaceVariant};
`;
